import { Routes } from "@angular/router";
import { roleGuard } from "@kno2/core/session";
import { featureGuard } from "@kno2/shared/features";
import { useIntegrationDocumentTypes } from "./cda-document-types/use-integration-document-types.resolver";
import { routes as networkIdentityProviderRoutes } from "./network-identity-providers/network-identity-providers.routes";
import { organizationResolver } from "./organization/organization.resolver";
import { planResolver } from "./organization/plan.resolver";

export const routes: Routes = [
    {
        path: "settings",
        data: {
            roles: ["Administrator"]
        },
        canActivateChild: [roleGuard],
        children: [
            {
                path: "addons",
                loadComponent: () => import("./addons").then((m) => m.AddonsComponent)
            },
            {
                path: "licensedplan",
                loadComponent: () => import("./licensed-plan").then((m) => m.LicensedPlanComponent)
            },
            {
                path: "organization",
                loadComponent: () => import("./organization").then((m) => m.OrganizationComponent),
                resolve: {
                    organization: organizationResolver,
                    subscriptionPlan: planResolver
                }
            },
            {
                path: "api",
                loadComponent: () => import("./api").then((m) => m.ApiComponent),
                children: [
                    {
                        path: "network",
                        loadComponent: () => import("./api/network/api-network.component").then((m) => m.ApiNetworkComponent),
                        data: { roles: ["NetworkAdmin"], features: ["NetworkServiceAccount"] }
                    }
                ]
            },
            {
                path: "contacts",
                loadComponent: () => import("./contacts").then((m) => m.ContactsComponent)
            },
            {
                path: "ipaddresses",
                canActivate: [featureGuard],
                data: {
                    features: ["WhitelistIpAddressesUI"]
                },
                loadComponent: () => import("./ip-addresses").then((m) => m.IpAddressesComponent)
            },
            {
                path: "identityproviders",
                loadComponent: () => import("./identity-providers").then((m) => m.IdentityProvidersComponent),
                canActivate: [featureGuard],
                data: {
                    features: ["PointClickCareIdentityProvider"]
                }
            },
            ...networkIdentityProviderRoutes,
            {
                path: "documenttypes",
                loadComponent: () => import("./document-types").then((m) => m.DocumentTypesComponent)
            },
            {
                path: "cdadocumenttypes",
                loadComponent: () => import("./cda-document-types").then((m) => m.CdaDocumentTypesComponent),
                data: {
                    features: ["CdaDocumentTypes"]
                },
                resolve: {
                    useIntegrationDocumentTypes: useIntegrationDocumentTypes
                }
            },
            {
                path: "downloadprofiles",
                loadComponent: () => import("./download-profiles").then((m) => m.DownloadProfilesComponent),
                data: {
                    features: ["MessageDownloadClient"]
                }
            },
            {
                path: "exports",
                loadComponent: () => import("./exports").then((m) => m.ExportsComponent)
            },
            {
                path: "releasetypes",
                loadComponent: () => import("./release-types").then((m) => m.ReleaseTypesComponent)
            },
            {
                path: "fax",
                loadComponent: () => import("./document-sources").then((m) => m.DocumentSourcesComponent)
            },
            {
                path: "directaddresses",
                loadComponent: () => import("./document-sources").then((m) => m.DocumentSourcesComponent)
            },
            {
                path: "users",
                loadComponent: () => import("./users").then((m) => m.UsersComponent)
            },
            {
                path: "efaxaccount",
                loadComponent: () => import("./efax-account").then((m) => m.EFaxAccountComponent),
                canActivate: [featureGuard],
                data: {
                    features: ["EnableExternalEFaxAccount"]
                }
            },
            {
                path: "rules",
                loadComponent: () => import("./rules").then((m) => m.RulesComponent)
            }
        ]
    }
];
